import React from 'react';
import PropTypes from 'prop-types'
import calendarIcon from './calendar.svg';

/**
 * The TicketViewSchedule component.
 *
 * @constructor
 */
export class TicketViewSchedule extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const scheduledTime = this.props.scheduledTime || null;
    return (
      <div className="ticket-view-schedule">
        <div className="media-object">
          <div className="media-object-section icon-wrapper">
            <img className="icon" src={calendarIcon} alt="schedule"/>
          </div>
          <div className="media-object-section">
            <div className="schedule-data">
              <h3>Scheduled Time</h3>

              {(scheduledTime) ? (
                <div>
                  <div className="schedule-time">{scheduledTime}</div>
                </div>
              ) : (
                <div>
                  <div className="schedule-time">Not Yet Scheduled</div>
                  <p className="schedule-helper-text">A WeGoLook agent will contact you soon</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TicketViewSchedule.propTypes = {
  scheduledTime: PropTypes.string
};

export default TicketViewSchedule;



// WEBPACK FOOTER //
// ./src/components/ticket/ticketViewSchedule/TicketViewSchedule.js